import { render } from "./initialStock.vue?vue&type=template&id=1e5b228a"
import script from "./initialStock.vue?vue&type=script&lang=js"
export * from "./initialStock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__